// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const SoftwareTypeSchema = z.enum(['VPN','MAIL','MAIL_SERVER','DB','DATABASE','FILE_SERVER','TERMINAL','WEB_SERVER','DNS','DNS_SERVER','PROXY','LOAD_BALANCER','CACHE','MESSAGE_QUEUE','SEARCH_ANALYTICS','DIRECTORY_SERVICE','IDENTITY','VOIP_TELEPHONY','MONITORING','BACKUP','CODE_HOSTING','BLOCKCHAIN_NODE','IOT_GATEWAY','CMS','FRAMEWORK','CDN','WAF','OTHER'] as const);

export type SoftwareTypeType = `${z.infer<typeof SoftwareTypeSchema>}`

export default SoftwareTypeSchema;
